module.exports = __webpack_public_path__ + "img/103078.49830497.png";